import './balloon-dropdown.scss'

import React, { ReactNode } from 'react'

interface BalloonDropdownProps {
  children: ReactNode
  className?: string
}

const BalloonDropdown = ({ className, children }: BalloonDropdownProps) => {
  if (!children) {
    return null
  }

  return (
    <div className={`balloonDropdown ${className ?? ''}`}>
      <div className="balloonDropdown-container">
        <div className="balloonDropdown-diamond">
          <div className="balloonDropdown-diamond-polygon" />
        </div>
        {children}
      </div>
    </div>
  )
}

export default BalloonDropdown
